import { render, staticRenderFns } from "./TeamCalendar.vue?vue&type=template&id=f370a818"
import script from "./TeamCalendar.vue?vue&type=script&lang=js"
export * from "./TeamCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports